import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/foodOperator/importer/foodOperatorImporterSelectors';
import FoodOperatorService from 'src/modules/foodOperator/foodOperatorService';
import fields from 'src/modules/foodOperator/importer/foodOperatorImporterFields';
import { i18n } from 'src/i18n';

const foodOperatorImporterActions = importerActions(
  'FOODOPERATOR_IMPORTER',
  selectors,
  FoodOperatorService.import,
  fields,
  i18n('entities.foodOperator.importer.fileName'),
);

export default foodOperatorImporterActions;